<template>
  <div>
    <div class="title-bar title-h4">알람 정보 확인</div>
    <el-row class="mr-b25">
      <div class="list form-list">
        <el-form :model="alarmDataInfo" ref="alarmForm" label-position="left">
          <el-form-item label="알람명" label-width="120px">{{alarmDataInfo.eventName}}</el-form-item>
          <el-form-item label="알람 활성화" label-width="120px">{{getAlarmActive(alarmDataInfo.applyFlag)}}</el-form-item>
          <el-form-item label="알람 종류" label-width="120px">{{getAlarmType(alarmDataInfo.eventType)}}</el-form-item>
          <el-form-item label="대상 저장소" label-width="120px" v-show="showDataindex()">{{ alarmDataInfo.dataindexName }}</el-form-item>
          <el-form-item label="알람 조건" label-width="120px">{{alarmDataInfo.eventConditionLabel}}</el-form-item>
          <el-form-item label="알람 조건값" label-width="120px">{{getEventValueFormat()}}</el-form-item>
          <el-form-item label="이벤트 등급" label-width="120px">
            <div v-html="getEventData(alarmDataInfo.eventSet)"></div>
          </el-form-item>
          <el-form-item label="수신자" label-width="120px">
            <div v-html="getMessageRecevier(alarmDataInfo.alarmReceiver)"></div>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { isTrue } from '@/utils/boolean';

export default {
  name: 'WAlarmInfoCheckView',
  props: {
    alarmData: {
      type: Object,
    },
    eventlevelSetting: {
      type: Array,
    },
  },
  watch: {
    alarmData: {
      deep: true,
      immediate: true,
      handler() {
        this.alarmDataInfo = cloneDeep(this.alarmData);
      },
    },
  },
  data() {
    return {
      alarmDataInfo: {},
    };
  },
  methods: {
    /**
     * 이벤트 타입에 따른 value 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getEventValueFormat() {
      let eventValue = '';
      switch (this.alarmDataInfo.eventType) {
        case 'KEYWORD_COUNT':
          eventValue = this.alarmDataInfo.eventValue;
          break;
        case 'ML_PATTERN':
          eventValue = this.alarmDataInfo.eventLabel;
          break;
        case 'UNKNOWN_PATTERN':
          eventValue = this.alarmDataInfo.eventLabel;
          break;
        case 'BASELINE':
          eventValue = this.alarmDataInfo.eventLabel;
          break;
        default:
          eventValue = this.alarmDataInfo.eventValue;
      }
      return eventValue;
    },
    /**
     * 저장소 데이터가 비어있는지 알려준다
     * @author leesy918
     * @return {[type]} [description]
     */
    showDataindex() {
      return !isNil(this.alarmDataInfo.dataindexId);
    },
    /**
     * 발생 조건을 제외한 조건의 이벤트 변환 함수
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getOtherEventSetting(data) {
      if (this.alarmDataInfo.eventType === 'STORAGE') {
        return `임계치 ${data.eventThreshold} % 이상 `;
      } else if (this.alarmDataInfo.eventType === 'UNKNOWN_PATTERN') {
        return `${data.eventThreshold} 회 발생`;
      } else if (this.alarmDataInfo.eventType === 'BASELINE') {
        let unit = '';
        switch (data.eventcheckTimeUnit) {
          case 'M':
            unit = '분';
            break;
          case 'H':
            unit = '시간';
            break;
          case 'D':
            unit = '일';
            break;
          default:
            unit = '초';
        }
        return `상한 ${data.eventcheckTime} ${unit} 내 ${data.eventThreshold}% 초과`;
      }
      return `상한 ${data.eventThreshold}% 초과`;
    },
    /**
     * 발생 조건 이벤트 변환 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getEventCountSetting(data) {
      let unit = '';
      switch (data.eventcheckTimeUnit) {
        case 'M':
          unit = '분';
          break;
        case 'H':
          unit = '시간';
          break;
        case 'D':
          unit = '일';
          break;
        default:
          unit = '초';
      }
      return `${data.eventcheckTime} ${unit} 내 ${data.eventThreshold} 회 발생`;
    },
    /**
     * 이벤트 등급 명 변환 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getEventLevelLabel(data) {
      const eventlevelId = this.eventlevelSetting.find((item) => item.eventlevelId === data);
      return eventlevelId.eventlevelName;
    },
    /**
     * 폼 아이템 -> 설정 이벤트 값 작성 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getEventData(data) {
      let messageDetail = '';
      if (!isNil(data)) {
        data.forEach((item, index) => {
          messageDetail += `<br/>이벤트 등급 : ${this.getEventLevelLabel(item.eventlevelId)} <br/>`;
          messageDetail += (this.alarmDataInfo.eventType === 'KEYWORD_COUNT' || this.alarmDataInfo.eventType === 'ML_PATTERN') ?
            `이벤트 설정 : ${this.getEventCountSetting(item)}<br/><br/>` : `이벤트 설정 : ${this.getOtherEventSetting(item)}<br/><br/>`;
          if (data.length >= 2 && data.length !== index + 1) {
            messageDetail += '<hr/>';
          }
        });
      }
      return messageDetail;
    },
    /**
     * 알람 타입 변환 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getAlarmType(data) {
      let logType = '';
      switch (data) {
        case 'KEYWORD_COUNT':
          logType = '발생횟수 알람';
          break;
        case 'UNKNOWN_PATTERN':
          logType = '미확인패턴 알람';
          break;
        case 'BASELINE':
          logType = '베이스라인 알람';
          break;
        case 'STORAGE':
          logType = '저장소 알람';
          break;
        case 'ML_PATTERN':
          logType = '머신러닝 알람';
          break;
        default:
          logType = '로그패턴 알람';
      }
      return logType;
    },
    /**
     * 알람 활성 여부 변환 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getAlarmActive(data) {
      return (isTrue(data)) ? '활성화' : '비활성화';
    },
    /**
     * 수신자 목록 작성 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getMessageRecevier(data) {
      let userName = '';
      if (!isNil(data)) {
        data.forEach((item, index) => {
          userName += (index < data.length - 1) ? `${item.managerName} /` : item.managerName;
        });
      }
      return userName;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmInfoCheckView.vue